import { useModel } from '@src/generic/model-store';
import { useState } from 'react';
import { getLocalStorageLanguage } from './localStorage';

const useTranslationInfo = (courseId) => {
  const { language } = useModel('coursewareMeta', courseId);
  const courseLanguage = language || 'en';
  const courseTranslationLanguage = getLocalStorageLanguage(courseId);
  const [selectedLanguage, updateSelectedLanguage] = useState(courseTranslationLanguage || courseLanguage);

  return {
    courseLanguage,
    selectedLanguage,
    updateSelectedLanguage,
    isTranslating: selectedLanguage !== courseLanguage,
  };
};

export default useTranslationInfo;
